import { render, staticRenderFns } from "./BranchRoleAdd.vue?vue&type=template&id=69281adf&scoped=true&"
import script from "./BranchRoleAdd.vue?vue&type=script&lang=js&"
export * from "./BranchRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69281adf",
  null
  
)

export default component.exports